/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInKeyTypeValuesItem: core.serialization.Schema<
    serializers.NotInKeyTypeValuesItem.Raw,
    Truvity.NotInKeyTypeValuesItem
> = core.serialization.enum_(['ED25519', 'P256', 'P384']);

export declare namespace NotInKeyTypeValuesItem {
    export type Raw = 'ED25519' | 'P256' | 'P384';
}
